import { Chatbox } from "@/gui/components/chat-box";
import { Navigation } from "@/gui/components/navigation-bar";
import { render } from "lit-html";
import { CustomAlert } from "@/gui/components/custom-alert";
import { TopBar } from "@/gui/components/top-bar";
import { Scene } from "excalibur";
import gameApp from "@/index";
import Location from "@/scenes/location";
import { CustomToast } from "./toast";

export default class Dashboard extends Scene {
  topbar: TopBar;
  navigation: Navigation;
  chatbox: Chatbox;
  customAlert: CustomAlert;

  constructor() {
    super();

    this.addEventListeners();
  }

  public getCameraZoom(): number {
    return gameApp.game.currentScene.camera.zoom;
  }

  public addEventListeners() {
    gameApp.game.input.pointers.primary.on("wheel", (evt) => {
      const zoomChange = evt.deltaY < 0 ? 0.005 : -0.005;
      gameApp.game.currentScene.camera.zoom += zoomChange;
      this.topbar.updateZoomLevel();
    });

    window.addEventListener("keydown", (evt) => {
      if ((evt.ctrlKey || evt.metaKey) && evt.key === "0") {
        gameApp.game.currentScene.camera.zoom = 1;
        evt.preventDefault();
        this.topbar.updateZoomLevel();
      }

      if (evt.key === "+" || evt.key === "=") {
        this.zoomIn();
        evt.preventDefault();
      }

      if (evt.key === "-") {
        this.zoomOut();
        evt.preventDefault();
      }
    });
  }

  public zoomIn(): void {
    const currentZoom = this.getCameraZoom();
    gameApp.setCameraZoom(currentZoom + 0.05);
    gameApp.dashboard?.topbar?.updateZoomLevel();
  }

  public zoomOut(): void {
    const currentZoom = this.getCameraZoom();
    gameApp.setCameraZoom(currentZoom - 0.05);
    gameApp.dashboard?.topbar?.updateZoomLevel();
  }

  public displayGameUI() {
    this.topbar = new TopBar();
    this.navigation = new Navigation();
    this.customAlert = new CustomAlert();

    const toast = new CustomToast();

    const gameUi = document.createElement("div");
    document.body.appendChild(gameUi);

    render([this.topbar, this.navigation, this.customAlert, toast], gameUi);
  }
}
